import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';
import { isAllowCopyTarget } from './securityPolicy';

const BLOCKED_KEYS = ['c', 'v', 'x', 'p', 's', 'u'];

export function isBlockedShortcut(event, policy) {
  if (!policy || !policy.blockKeyboardShortcuts) return null;
  const key = String(event.key || '').toLowerCase();
  const ctrlOrMeta = event.ctrlKey || event.metaKey;

  if (key === 'f12') return { reason: 'devtools', key: event.key };
  if (ctrlOrMeta && event.shiftKey && ['i', 'j', 'c'].includes(key)) {
    return { reason: 'devtools', key: event.key };
  }
  if (event.metaKey && event.altKey && ['i', 'j', 'c'].includes(key)) {
    return { reason: 'devtools', key: event.key };
  }
  if (ctrlOrMeta && BLOCKED_KEYS.includes(key)) {
    if (['c', 'v', 'x'].includes(key) && isAllowCopyTarget(event.target)) return null;
    return { reason: 'shortcut', key: event.key };
  }
  return null;
}

export function subscribeKeyboardGuard(logSecurityEvent, policy) {
  if (typeof document === 'undefined' || !policy.blockKeyboardShortcuts) return () => {};

  const onKeyDown = (event) => {
    const blocked = isBlockedShortcut(event, policy);
    if (!blocked) return;
    event.preventDefault();
    const isPrint = String(event.key || '').toLowerCase() === 'p';
    logSecurityEvent({
      type: isPrint ? SECURITY_EVENTS.PRINT_ATTEMPT : SECURITY_EVENTS.BLOCKED_SHORTCUT,
      severity: isPrint
        ? EVENT_SEVERITY[SECURITY_EVENTS.PRINT_ATTEMPT]
        : EVENT_SEVERITY[SECURITY_EVENTS.BLOCKED_SHORTCUT],
      message: isPrint ? 'Print shortcut intercepted' : 'Blocked keyboard shortcut',
      metadata: {
        key: event.key,
        ctrl: event.ctrlKey,
        meta: event.metaKey,
        shift: event.shiftKey,
        alt: event.altKey,
        reason: blocked.reason
      }
    });
  };

  document.addEventListener('keydown', onKeyDown, true);
  return () => document.removeEventListener('keydown', onKeyDown, true);
}
